// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"031c03fc","352":"93ca12b3","561":"3a19b32b","671":"b6cdd800","726":"18c6102a"}[chunkId] + ".chunk.js";
};